import GridHelper from '@locomotivemtl/grid-helper';
import { $screen } from './stores/screen.js';
import { ENV } from './config.js';

export default async function () {
    let tailwindConfig = await import('../../tailwind.config.js');
    tailwindConfig = tailwindConfig.default;

    /**
     * Initialize the grid helper
     */
    if (process.env.NODE_ENV === 'development') {
        new GridHelper({
            columns: 'var(--grid-columns)',
            gutterWidth: `var(--grid-gutter, ${tailwindConfig?.theme?.extend?.gap?.gutter})`,
            marginWidth: `var(--grid-margin, ${tailwindConfig?.theme?.extend?.spacing?.containerMargin})`
        });
    }

    /**
     * Set viewport sizes
     */
    $screen.subscribe(() => {
        // Document styles
        const documentStyles = document.documentElement.style;

        // Viewport width
        const vw = document.body.clientWidth * 0.01;
        documentStyles.setProperty('--vw', `${vw}px`);

        // Return if browser supports vh, svh, dvh, & lvh
        if (ENV.SUPPORTS_VH) {
            return;
        }

        // Viewport height
        const svh = document.documentElement.clientHeight * 0.01;
        documentStyles.setProperty('--svh', `${svh}px`);

        const dvh = window.innerHeight * 0.01;
        documentStyles.setProperty('--dvh', `${dvh}px`);

        if (document.body) {
            const fixed = document.createElement('div');
            fixed.style.width = '1px';
            fixed.style.height = '100vh';
            fixed.style.position = 'fixed';
            fixed.style.left = '0';
            fixed.style.top = '0';
            fixed.style.bottom = '0';
            fixed.style.visibility = 'hidden';

            document.body.appendChild(fixed);

            var fixedHeight = fixed.clientHeight;

            fixed.remove();

            const lvh = fixedHeight * 0.01;

            documentStyles.setProperty('--lvh', `${lvh}px`);
        }
    });
}
